import {
    AppBar,
    Box,
    Hidden,
    IconButton,
    makeStyles,
    Toolbar,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';

const useStyles = makeStyles((theme) => ({
    root: {
        background: '#fff',
    },
    logo: {
        width: 50,
        height: 50,
        margin: '10px 0',
    },
}));

const TopBar = ({ onMobileNavOpen }) => {
    const classes = useStyles();

    return (
        <Hidden mdUp>
            <AppBar color='secondary' className={classes.root}>
                <Toolbar>
                    <NavLink to='/'>
                        <img
                            src={logo}
                            alt='dm games'
                            className={classes.logo}
                        />
                    </NavLink>
                    <Box flexGrow={1} />
                    <Hidden lgUp>
                        <IconButton color='inherit' onClick={onMobileNavOpen}>
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                </Toolbar>
            </AppBar>
        </Hidden>
    );
};

export default TopBar;
